import { ReactComponent as Search } from '../../assets/icons/search.svg'

import styles from './SearchBar.module.scss'

interface ISearchBarProps {
    value: string
    onChange: (value: string) => void
}

export const SearchBar = (props: ISearchBarProps) => {
    const { value, onChange } = props

    return (
        <label className={styles.searchBar__label} htmlFor="search">
            <input
                className={styles.searchBar__input}
                name="search"
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
            <Search className={styles.searchBar__icon} alt="Search" />
        </label>
    )
}
